export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '中档信息',

    /** 公司名称 */
    name: '中档信息（广东）有限公司',
    /** 公司微信 */
    wechat: 'zd-ams',
    /** 公司邮箱 */
    email: 'ljz@zhongdang.com.cn',
    /** 公司手机 */
    phone: '18927602067',
    /** 公司电话 */
    tel: '0759-2218817',
    /** 公司地址 */
    address: '湛江经济技术开发区海滨大道北95号七里大院二层中档集团',
    /** 备案号 */
    keepOnRecordIcp: '粤ICP备2021025357号-1',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 	110.403984,
        latitude: 21.264442,
        title: '七里大院二层',
        address: '（广东公司地址）'
    }
}



// WEBPACK FOOTER //
// ./src/config/index.js